export default __webpack_public_path__ + "static/designer-ali-otmani-606ff552266e19d9cf7e38e02a8728ad.png";